const { 
  REACT_APP_API_BASE,
  REACT_APP_ADDRESS_API,
  REACT_APP_API_KEY,
  REACT_APP_CDN_BASE,
  REACT_APP_CDN_IMAGES_BASE,
  REACT_APP_IFRAME_BASE,
  REACT_APP_ADOPT_BASE,
  REACT_APP_KIOSK_BASE,
  REACT_APP_GLOBAL_API,
  REACT_APP_INTEGRATION_API,
  REACT_APP_MAGIC_LINK_API,
  REACT_APP_API_SERVICE_URL,
} = process.env

interface IConfig {
  baseAPI: string,
  integrationAPI: string,
  addressAPI: string,
  apiKey: string,
  cdnBase: string,
  cdnImagesBase: string,
  iframeBase: string,
  adoptBase: string,
  kioskBase: string,
  globalAPI: string,
  magicLinkAPI: string
  serviceAPI: string
}

export default {
  baseAPI: REACT_APP_API_BASE || 'http://localhost',
  integrationAPI: REACT_APP_INTEGRATION_API || 'http://localhost',
  addressAPI: REACT_APP_ADDRESS_API,
  apiKey: REACT_APP_API_KEY || '',
  cdnBase: REACT_APP_CDN_BASE || '',
  cdnImagesBase: REACT_APP_CDN_IMAGES_BASE || '',
  iframeBase: REACT_APP_IFRAME_BASE || '',
  adoptBase: REACT_APP_ADOPT_BASE || '',
  kioskBase: REACT_APP_KIOSK_BASE || '',
  globalAPI: REACT_APP_GLOBAL_API || '',
  magicLinkAPI: REACT_APP_MAGIC_LINK_API || '',
  serviceAPI: REACT_APP_API_SERVICE_URL || '',
} as IConfig
